'use strict';

wbApp.factory('recipientSvc', ['$translate', '$filter', '$http', '$q', 'notificationSvc', 'semesterSvc', 'courseSvc', 'classroomSvc', 'compensationGroupSvc', 'studentSvc', 'userSvc',
    function ($translate, $filter, $http, $q, notificationSvc, semesterSvc, courseSvc, classroomSvc, compensationGroupSvc, studentSvc, userSvc) {

        function createRecipientModel() {
            function Recipient() {
                this.recipientGroupType = 1;
                this.activeOnly = true;
                this._name = null;
            }

            Recipient.prototype.getName = function () {

                if (this._name) {
                    return this._name;
                }

                var groupType = parseInt(this.recipientGroupType);
                var str = "{0} ({1})";
                var str2 = "{0} ({1} - {2})";
                var me = this;

                switch (groupType) {
                    case 1:
                        me._name = $translate.instant('TXT_VAL_RCPG_USER');
                        userSvc.getByIDAsync(me.userId).$promise.then(function (user) {
                            me._name = str.f($translate.instant('TXT_VAL_RCPG_USER'), user.fullName);
                        });
                        break;
                    case 2:
                        me._name = $translate.instant('TXT_LOADING_DATA');
                        courseSvc.getCourseAsync(parseInt(me.semesterId), parseInt(me.courseId)).then(function (course) {
                            me._name = str.f($translate.instant('TXT_VAL_RCPG_COURSE'), $filter('courseFullName')(course));
                        });                        
                        break;
                    case 3:
                        me._name = $translate.instant('TXT_LOADING_DATA');
                        courseSvc.getCourseAsync(parseInt(me.semesterId), parseInt(me.courseId)).then(function (course) {
                            me._name = str.f($translate.instant('TXT_VAL_RCPG_COURSE_LESSON'), $filter('courseFullName')(course));
                        });                        
                        break;
                    case 4:
                        me._name = $translate.instant('TXT_LOADING_DATA');
                        $q.all([
                            classroomSvc.getAsync(parseInt(me.classroomId)),
                            semesterSvc.getAsync(parseInt(me.semesterId))]
                        ).then(function (allData) {
                            me._name = str2.f($translate.instant('TXT_VAL_RCPG_CLASSROOM'), allData[0].name, allData[1].name);
                        });
                        break;
                    case 5:
                        me._name = $translate.instant('TXT_LOADING_DATA');
                        classroomSvc.getAsync(parseInt(me.classroomId)).then(function (classroom) {
                            me._name = str2.f($translate.instant('TXT_VAL_RCPG_CLASSROOM_AT_DATE'), classroom.name, $filter('date')(me.toDate, 'dd.MM.yy'));
                        });
                        break;
                    case 6:
                        me._name = $translate.instant('TXT_LOADING_DATA');
                        compensationGroupSvc.getAsync(parseInt(me.compensationGroupId)).then(function (compensationGroup) {
                            me._name = str.f($translate.instant('TXT_VAL_RCPG_COMPENSATION_GROUP'), compensationGroup.name);
                        });
                        break;
                    case 7:
                        me._name = $translate.instant('TXT_LOADING_DATA');
                        semesterSvc.getAsync(parseInt(me.semesterId)).then(function (semester) {
                            me._name = str.f($translate.instant('TXT_VAL_RCPG_ALL_COURSES'), semester.name);
                        });
                        break;
                    case 8:
                        me._name = $translate.instant('TXT_LOADING_DATA');
                        semesterSvc.getAsync(parseInt(me.semesterId)).then(function (semester) {
                            me._name = str.f($translate.instant('TXT_VAL_RCPG_ALL_ACTIONS'), semester.name);
                        });                        
                        break;
                    case 9:
                        me._name = $translate.instant('TXT_LOADING_DATA');
                        semesterSvc.getAsync(parseInt(me.semesterId)).then(function (semester) {
                            me._name = str.f($translate.instant('TXT_VAL_RCPG_ALL_ACTIONS_WITHOUT_COURSES'), semester.name);
                        });
                       
                        break;
                    case 10:
                        me._name = $translate.instant('TXT_LOADING_DATA');
                        semesterSvc.getAsync(parseInt(me.semesterId)).then(function (semester) {
                            me._name = str.f($translate.instant('TXT_VAL_RCPG_SEMESTER'), semester.name);
                        });                        
                        break;
                    case 11:
                        me._name = $translate.instant('TXT_LOADING_DATA');
                        semesterSvc.getAsync(parseInt(me.semesterId)).then(function (semester) {
                            me._name = str.f($translate.instant('TXT_VAL_RCPG_NOT_IN_SEMESTER'), semester.name);
                        });
                        break;
                    case 12:
                        me._name = $translate.instant('TXT_LOADING_DATA');
                        semesterSvc.getAsync(parseInt(me.semesterId)).then(function (semester) {
                            me._name = str.f($translate.instant('TXT_VAL_RCPG_NOT_IN_SEMESTER_ATTENDING_LAST_ONE'), semester.name);
                        });
                        
                        break;
                    case 13:
                        me._name = $translate.instant('TXT_LOADING_DATA');
                        semesterSvc.getAsync(parseInt(me.semesterId)).then(function (semester) {
                            me._name = str.f($translate.instant('TXT_VAL_RCPG_NOT_IN_SEMESTR_NO_ACTIONS'), semester.name);
                        });
                        break;
                    case 14:
                        me._name = $translate.instant('TXT_LOADING_DATA');
                        semesterSvc.getAsync(parseInt(me.semesterId)).then(function (semester) {
                            me._name = str.f($translate.instant('TXT_VAL_RCPG_NOT_IN_SEMESTR_NO_ACTIONS_ATTENDING_LAST_ONE'), semester.name);
                        });                        
                        break;
                    case 15:
                        me._name = str.f($translate.instant('TXT_VAL_RCPG_ALL_AT_DATE'), $filter('date')(me.toDate, 'dd.MM.yy'));
                        break;
                    case 16:
                        me._name = $translate.instant('TXT_VAL_RCPG_STUDENT');
                        studentSvc.getByIDAsync(parseInt(me.studentId)).$promise.then(function (student) {
                            me._name = str.f($translate.instant('TXT_VAL_RCPG_STUDENT'), student.fullName);
                        });
                        break;
                    case 17:
                        me._name = $translate.instant('TXT_VAL_RCPG_STUDENT');
                        courseSvc.getActionAsync(parseInt(me.semesterId), parseInt(me.courseId)).then(function (course) {
                            me._name = str.f($translate.instant('TXT_VAL_RCPG_ACTION'), $filter('courseFullName')(course));
                        });
                        break;
                    case 18:
                        me._name = $translate.instant('TXT_VAL_RCPG_ALL');
                        break;
                    default:
                        me._name = '== error ==';
                        break;
                }

                return this._name;
            }

            Object.defineProperty(Recipient.prototype, 'name', {
                enumerable: true, configurable: true,
                get: function () { return this.getName(); }
            });

            return new Recipient();
        }

        function getAddressList(recipientList) {
            var deferred = $q.defer();

            $http({
                method: 'POST',
                url: 'Api/Messages/ResolveRecipients',
                data: recipientList
            })
            .success(function (data, status, headers, config) {

                var list = '';
                for (var i = 0; i < data.length; i++) {
                    list += data[i].fullName + ' <' + data[i].emailAddress + '>';
                    if (i < data.length - 1) {
                        list += ';';
                    }
                }

                deferred.resolve(list);
            })
            .error(function (data, status, headers, config) {
                deferred.reject(data);
                notificationSvc.notifyError(
                    $translate.instant('TXT_ALERT_TITLE_ENTITY_GET_ERROR'),
                    notificationSvc.translateError(data));
            });

            return deferred.promise;
        }

        return {
            createRecipientModel: createRecipientModel,
            getAddressList: getAddressList
        }
}]);